import React, { useCallback, useContext } from "react";
import { ThemeContext } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { Card, Text } from "rebass";

import { getFontSize, getIsOrigin } from "../../../store/modules/display/selectors";
import { decreaseFontSize, increaseFontSize } from "../../../store/modules/display/actions";

import { FontSizeButton } from "./FontSizeButton";

export const FontSizeControl: React.FC = () => {
  const { fontSizes } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const fontSize = useSelector(getFontSize);
  const isOrigin = useSelector(getIsOrigin);
  const decrease = useCallback(() => {
    dispatch(decreaseFontSize());
  }, [dispatch]);
  const increase = useCallback(() => {
    dispatch(increaseFontSize());
  }, [dispatch]);

  return (
    <Card
      borderBottom="2px solid"
      borderBottomColor="#ededed"
      css="display: flex;"
    >
      <FontSizeButton
        borderRight="1px solid"
        disabled={isOrigin || fontSize <= 0}
        onClick={decrease}
      >
        <Text fontSize="16px" fontWeight={400} lineHeight="1">a</Text>
      </FontSizeButton>

      <FontSizeButton
        borderLeft="1px solid"
        disabled={isOrigin || fontSize >= fontSizes.length - 1}
        onClick={increase}
      >
        <Text fontSize="30px" fontWeight={400} lineHeight="1">a</Text>
      </FontSizeButton>
    </Card>
  );
};
